import { __decorate } from "tslib";
import { attr, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { foundationToastStyles as styles } from './toast.styles';
import { foundationToastTemplate as template } from './toast.template';
// explicitly declaring for extensibility
export const foundationToastShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
export const defaultToastConfig = {};
/**
 * @tagname %%prefix%%-toast
 */
export class Toast extends FoundationElement {
    constructor() {
        super(...arguments);
        this.deleteAnimation = '';
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        this.closeTimeout = 10000;
        this.autoClose = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.autoClose) {
            setTimeout(() => {
                this.deleteAnimation = 'toast-delete';
                this.toast.onanimationend = () => {
                    this.remove();
                };
            }, this.closeTimeout);
        }
    }
    /**
     * Remove the toast from display.
     */
    close() {
        this.remove();
    }
}
__decorate([
    observable
], Toast.prototype, "deleteAnimation", void 0);
__decorate([
    attr({ attribute: 'close-timeout' })
], Toast.prototype, "closeTimeout", void 0);
__decorate([
    attr({ attribute: 'auto-close' })
], Toast.prototype, "autoClose", void 0);
/**
 * The Foundation Toast
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-toast\>
 */
export const foundationToast = Toast.compose(Object.assign({ baseName: 'toast', styles,
    template, shadowOptions: foundationToastShadowOptions }, defaultToastConfig));
